import { formatDate as formatLocalizedDate } from '@repo/i18n';
import { getLocale } from '@repo/i18n/browser';
export const formatDate = (date: string | Date) =>
  formatLocalizedDate(date, getLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
